"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalState = void 0;
var immer_1 = __importDefault(require("immer"));
var GlobalStateStore_1 = require("./GlobalStateStore");
var useGlobalStateReducer_1 = require("./useGlobalStateReducer");
function useGlobalState(globalState, config) {
    if (config === void 0) { config = { persist: true }; }
    if (typeof globalState === 'string') {
        globalState = GlobalStateStore_1.store.getState(globalState, config);
    }
    function reducer(currentState, newState) {
        return newState;
    }
    var _a = useGlobalStateReducer_1.useGlobalStateReducer(reducer, globalState, config), state = _a[0], setState = _a[1];
    var globalStateValue = state;
    if (config.selector && !config.patcher) {
        globalStateValue = globalState.getValue();
    }
    function updateState(fn) {
        var newState = immer_1.default(globalStateValue, fn);
        setState(newState);
    }
    return [state, setState, updateState];
}
exports.useGlobalState = useGlobalState;
